import { without } from 'lodash-es';

export enum OrganizationTypes {
  Sandbox = 'sandbox',
  Internal = 'internal',
  Explorer = 'explorer',
  Partner = 'partner',
  Innovator = 'innovator',
  Utopia = 'utopia',
  Intergalactic = 'intergalactic',
  CreatorDeveloper = 'creator developer',
  EnterpriseDeveloper = 'enterprise developer',
  EnterpriseSandbox = 'enterprise sandbox',
  Academic = 'academic',
  Basic = 'basic',
  Basic3 = 'basic3',
  Plus = 'plus',
  Plus2 = 'plus2',
  Plus3 = 'plus3',
  Pro = 'pro',
  Pro2 = 'pro2',
  Pro3 = 'pro3',
  Elite = 'elite',
  ProPlus = 'proplus',
  ProTeam = 'proteam',
  ProCustom = 'procustom',
  ProPremium = 'propremium',
  Other = 'other',
}

export const allOrgTypes = Object.values(OrganizationTypes);
export const internalOrgTypes = [OrganizationTypes.Internal];
export const externalOrgTypes = without(allOrgTypes, ...internalOrgTypes);

export const orgTypesWithLimitedAccess: string[] = [OrganizationTypes.Explorer];

// ideally the possible values here would be expressed as OrganizationTypes but doing so
// means you can't assign a string value to a variable of type SelfSignUpOrgType
export const selfSignUpOrgTypes = [
  'sandbox',
  'basic3',
  'plus3',
  'pro3',
  'propremium',
  'elite',
] as const;
export type SelfSignUpOrgType = (typeof selfSignUpOrgTypes)[number];
